import { createAction } from '@reduxjs/toolkit';

import { AppState } from 'bootstrap.store';

const prefix = 'sync';

export const syncActions = {
  state: createAction<{ state: Partial<AppState> }>(`${prefix}/state`),
};
